module.exports = __webpack_public_path__ + "img/setup.62da2a7b.svg";